<footer class="footer no-print" role="contentinfo">
  <div class="footer__content">
    <ul class="footer__links">
      <li><a href="https://www.spglobal.com/spdji/en/about-us" target="" data-gtm-category="Footer" data-gtm-action="Support"
             data-gtm-label="About S&amp;P Dow Jones Indices" lang="en-us">About S&amp;P Dow Jones Indices</a></li>
      <li><a href="https://www.spglobal.com/spdji/en/about-us/our-services" target="" data-gtm-category="Footer" data-gtm-action="Support"
             data-gtm-label="Our Services" lang="en-us">Our Services</a></li>
      <li><a href="https://www.spglobal.com/spdji/en/media-center/news-announcements" target="" data-gtm-category="Footer"
             data-gtm-action="Support" data-gtm-label="Media Center" lang="en-us">Media Center</a></li>
      <li><a href="https://www.spglobal.com/spdji/en/contact-us" target="_blank" data-gtm-category="Footer" data-gtm-action="Support"
             data-gtm-label="Contact Us" lang="en-us">Contact Us</a></li>
    </ul>
    <ul class="footer__secondary-links">
      <li><a href="https://careers.spglobal.com/ListJobs/ByCustom/Segment/Keyword-S-P-Dow-Jones-Indices"
             data-gtm-category="Footer" data-gtm-action="Outbound Link_Division" data-gtm-label="Careers" lang="en-us">Careers</a>
      </li>
      <li><a href="https://www.spglobal.com/en/who-we-are/corporate-responsibility/overview" data-gtm-category="Footer"
             data-gtm-action="Outbound Link_Division" data-gtm-label="Corporate Responsibility" lang="en-us">Corporate
        Responsibility</a></li>
      <li><a href="https://www.spglobal.com/en/who-we-are/our-history" data-gtm-category="Footer"
             data-gtm-action="Outbound Link_Division" data-gtm-label="History" lang="en-us">History</a></li>
      <li><a href="http://investor.spglobal.com" data-gtm-category="Footer" data-gtm-action="Outbound Link_Division"
             data-gtm-label="Investor Relations" lang="en-us">Investor Relations</a></li>
      <li><a href="https://www.spglobal.com/spdji/en/our-leadership" data-gtm-category="Footer"
             data-gtm-action="Outbound Link_Division" data-gtm-label="Leadership" lang="en-us">Leadership</a></li>
    </ul>
    <div class="footer__bottom-wrapper">
      <ul class="footer__notice">
        <li>© 2023 S&amp;P Dow Jones Indices</li>
        <li><a href="https://www.spglobal.com/spdji/en/disclaimers" data-gtm-category="Footer" data-gtm-action="Support"
               data-gtm-label="Legal Disclaimers" lang="en-us">Legal Disclaimers</a></li>
        <li><a href="https://www.spglobal.com/en/terms-of-use" data-gtm-category="Footer" data-gtm-action="Support"
               data-gtm-label="Terms of Use" lang="en-us">Terms of Use</a></li>
        <li><a href="https://www.spglobal.com/en/privacy/privacy-policy-english" data-gtm-category="Footer"
               data-gtm-action="Support" data-gtm-label="Privacy Policy" lang="en-us">Privacy Policy</a></li>
        <li><a href="https://www.spglobal.com/en/cookie-notice" data-gtm-category="Footer" data-gtm-action="Support"
               data-gtm-label="Cookie Notice" lang="en-us">Cookie Notice</a></li>
        <li><a href="https://www.spglobal.com/en/privacy/california-consumer-privacy-act" data-gtm-category="Footer"
               data-gtm-action="Support" data-gtm-label="Do Not Sell My Personal Information" lang="en-us">Do Not Sell
          My Personal Information</a></li>
        <li><a href="https://www.spglobal.com/spdji/en/complaints-handling-policy" data-gtm-category="Footer"
               data-gtm-action="Support" data-gtm-label="Complaints" lang="en-us">Complaints</a></li>
        <li>
<!--          <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>-->
        </li>
      </ul>
      <ul class="footer__social">
        <li><a href="https://on.spdji.com/SignUp?src=IDS" target="_blank" data-gtm-category="Footer"
               data-gtm-action="Outbound Link_Social" data-gtm-label="Email" aria-label="" lang="en-us"><i
          class="fa fa-envelope"></i></a></li>
        <li><a href="https://twitter.com/SPDJIndices" target="_blank" data-gtm-category="Footer"
               data-gtm-action="Outbound Link_Social" data-gtm-label="Twitter" aria-label="" lang="en-us"><i
          class="fa fa-twitter"></i></a></li>
        <li><a href="https://www.linkedin.com/company/s&amp;p-dow-jones-indices" target="_blank"
               data-gtm-category="Footer" data-gtm-action="Outbound Link_Social" data-gtm-label="LinkedIn" aria-label=""
               lang="en-us"><i class="fa fa-linkedin-square"></i></a></li>
        <li><a href="https://www.facebook.com/SP-Dow-Jones-Indices-161630018534/" target="_blank"
               data-gtm-category="Footer" data-gtm-action="Outbound Link_Social" data-gtm-label="Facebook" aria-label=""
               lang="en-us"><i class="fa fa-facebook"></i></a></li>
        <li><a href="https://www.youtube.com/user/SPIndicesChannel" target="_blank" data-gtm-category="Footer"
               data-gtm-action="Outbound Link_Social" data-gtm-label="YouTube" aria-label="" lang="en-us"><i
          class="fa fa-youtube "></i></a></li>
        <li><a href="https://www.spglobal.com/spdji/en/rss" target="_blank" data-gtm-category="Footer"
               data-gtm-action="Outbound Link_Social" data-gtm-label="RSS" aria-label="" lang="en-us"><i
          class="fa fa-rss"></i></a></li>
      </ul>
    </div>
  </div>
</footer>
